import { render, staticRenderFns } from "./abstractFormMobile.vue?vue&type=template&id=1f38c860&scoped=true"
import script from "./abstractFormMobile.vue?vue&type=script&lang=js"
export * from "./abstractFormMobile.vue?vue&type=script&lang=js"
import style0 from "./abstractFormMobile.vue?vue&type=style&index=0&id=1f38c860&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38c860",
  null
  
)

export default component.exports